// Elektrik disiplini için sertifika / eğitim / yetki belgesi şablonları
// Kaynak: docs/egitimler.md (Nisan 2026)
// Kategoriler Projabze Sertifika Modülü önerisine göre (bölüm 10.1), veren kurum
// enum'ı 10.2'ye göre, doğrulama linkleri 10.3'e göre.

// Veren kurum enum — projeksiyonda tek kaynağa bağlı filtreleme için
const ISSUERS = [
  { key: 'EMO', label: 'EMO — Elektrik Mühendisleri Odası' },
  { key: 'MMO', label: 'MMO — Makina Mühendisleri Odası' },
  { key: 'TEDAŞ', label: 'TEDAŞ' },
  { key: 'TEİAŞ', label: 'TEİAŞ' },
  { key: 'EÜAŞ', label: 'EÜAŞ' },
  { key: 'MYK', label: 'MYK — Mesleki Yeterlilik Kurumu' },
  { key: 'MEB', label: 'MEB — Millî Eğitim Bakanlığı' },
  { key: 'EPDK', label: 'EPDK' },
  { key: 'ETKB', label: 'ETKB — Enerji ve Tabii Kaynaklar Bakanlığı' },
  { key: 'Üniversite SEM', label: 'Üniversite SEM / USEM' },
  { key: 'Adalet Bakanlığı', label: 'Adalet Bakanlığı' },
  { key: 'Çevre Şehircilik Bakanlığı', label: 'Çevre, Şehircilik ve İklim Değişikliği Bakanlığı' },
  { key: 'Sanayi Bakanlığı', label: 'Sanayi ve Teknoloji Bakanlığı' },
  { key: 'Diğer', label: 'Diğer' },
];

// Projabze Sertifika Modülü — bölüm 10.1 kategorileri
const CERT_CATEGORIES = [
  'Yetki Belgeleri (İmza Yetkisi)',
  'Sorumluluk Belgeleri',
  'Çalışma İzin Belgeleri',
  'Uzmanlık Sertifikaları',
  'Ulusal Yeterlilik (Saha)',
  'Tamamlayıcı Eğitim',
  'MEB Belgeleri',
  'Bilirkişilik',
  'LPG / EPDK',
];

const ELECTRICAL_CERTIFICATES = [
  // ─── 1. Yetki Belgeleri (İmza Yetkisi) — EMO MİSEM ─────────────────
  {
    id: 'smm-1kv-alti',
    name: 'Elektrik 1 kV Altı Tesisler SMM Belgesi',
    issuer: 'EMO',
    category: 'Yetki Belgeleri (İmza Yetkisi)',
    scope: '1000 V altı kuvvetli/zayıf akım + asansör tesisleri',
    verifyUrl: 'https://portal.emo.org.tr',
    renewalYearly: true,
  },
  {
    id: 'smm-1kv-alti-ustu',
    name: 'Elektrik 1 kV Altı ve Üstü SMM Belgesi',
    issuer: 'EMO',
    category: 'Yetki Belgeleri (İmza Yetkisi)',
    scope: 'Kuvvetli akım tüm tesisler + cer hatları + maden + asansör',
    verifyUrl: 'https://portal.emo.org.tr',
    renewalYearly: true,
  },
  {
    id: 'smm-asansor',
    name: 'Asansör SMM Belgesi',
    issuer: 'EMO',
    category: 'Yetki Belgeleri (İmza Yetkisi)',
    scope: 'Asansör proje/denetim',
    verifyUrl: 'https://portal.emo.org.tr',
  },
  {
    id: 'btb',
    name: 'Büro Tescil Belgesi (BTB)',
    issuer: 'EMO',
    category: 'Yetki Belgeleri (İmza Yetkisi)',
    scope: 'Yıllık yenileme',
    verifyUrl: 'https://portal.emo.org.tr',
    renewalYearly: true,
  },

  // ─── 2. Sorumluluk Belgeleri ───────────────────────────────────────
  {
    id: 'yg-isletme',
    name: 'YG (Yüksek Gerilim) Tesislerinde İşletme Sorumluluğu',
    issuer: 'EMO',
    category: 'Sorumluluk Belgeleri',
    scope: 'Trafo merkezi olan işletmeler — aylık 1+ denetim zorunlu',
    verifyUrl: 'https://portal.emo.org.tr',
  },
  {
    id: 'ag-isletme',
    name: 'AG (Alçak Gerilim) İşletme Sorumluluğu',
    issuer: 'EMO',
    category: 'Sorumluluk Belgeleri',
    scope: 'AG tesisleri',
    verifyUrl: 'https://portal.emo.org.tr',
  },
  {
    id: 'asansor-muh-yetki',
    name: 'Asansör Mühendis Yetkilendirme',
    issuer: 'EMO',
    category: 'Sorumluluk Belgeleri',
    scope: 'Asansör üretim/denetim yetkisi',
  },
  {
    id: 'asansor-periyodik-muayene',
    name: 'Asansör Periyodik Kontrol Muayene Elemanı',
    issuer: 'MMO',
    category: 'Sorumluluk Belgeleri',
    scope: 'A Tipi Muayene Kuruluşu personeli (SGM 2015/24 + 2016/18)',
  },
  {
    id: 'lpg-sorumlu-mudur-mmo',
    name: 'LPG Otogaz İstasyonları Sorumlu Müdür',
    issuer: 'MMO',
    category: 'Sorumluluk Belgeleri',
    scope: 'LPG istasyonu — 3 gün eğitim + sınav (min 70/100)',
  },

  // ─── 3. Çalışma İzin Belgeleri — EKAT ──────────────────────────────
  {
    id: 'ekat-tedas',
    name: 'EKAT (TEDAŞ) — Elektrik Kuvvetli Akım YG Altında Çalışma İzin Belgesi',
    issuer: 'TEDAŞ',
    category: 'Çalışma İzin Belgeleri',
    scope: "36 kV'a kadar YG dağıtım ve tüketim tesisleri",
    verifyUrl: 'https://turkiye.gov.tr',
    note: 'E-Devlet üzerinden barkodlu sorgulanabilir. 136 saat (88 teori + 48 uygulama) + 50 soruluk sınav, min 70 puan.',
  },
  {
    id: 'ekat-teias',
    name: 'EKAT (TEİAŞ)',
    issuer: 'TEİAŞ',
    category: 'Çalışma İzin Belgeleri',
    scope: "İletim gerilim seviyesinden bağlı iletim/tüketim + 36 kV altı YG bölümleri",
  },
  {
    id: 'ekat-euas',
    name: 'EKAT (EÜAŞ)',
    issuer: 'EÜAŞ',
    category: 'Çalışma İzin Belgeleri',
    scope: 'Elektrik üretim tesisleri',
  },

  // ─── 4. Uzmanlık Sertifikaları ─────────────────────────────────────
  {
    id: 'ekb-uzman',
    name: 'Enerji Kimlik Belgesi (EKB) Uzmanı',
    issuer: 'ETKB',
    category: 'Uzmanlık Sertifikaları',
    scope: 'Bina EKB düzenleme (BEP-TR)',
    note: 'Onay yetkisi için SMM + İTB veya yetkili EVD şirketi bağlantısı gerekir.',
  },
  {
    id: 'enerji-yoneticisi-bina',
    name: 'Enerji Yöneticisi — Bina (MİSEM Kod 33.0001)',
    issuer: 'ETKB',
    category: 'Uzmanlık Sertifikaları',
    scope: 'Bina enerji yönetimi (2 modül: teorik + uygulamalı)',
  },
  {
    id: 'enerji-yoneticisi-sanayi',
    name: 'Enerji Yöneticisi — Sanayi',
    issuer: 'ETKB',
    category: 'Uzmanlık Sertifikaları',
    scope: 'Endüstriyel işletmede enerji yönetimi',
  },
  {
    id: 'etut-proje-bina',
    name: 'Bina Etüt-Proje Sertifikası',
    issuer: 'ETKB',
    category: 'Uzmanlık Sertifikaları',
    scope: '3 modül × min 40 saat — bina enerji etüdü',
  },
  {
    id: 'etut-proje-sanayi',
    name: 'Sanayi Etüt-Proje Sertifikası',
    issuer: 'ETKB',
    category: 'Uzmanlık Sertifikaları',
    scope: '3 modül — sanayi tesisi enerji etüdü',
  },
  {
    id: 'olcme-dogrulama',
    name: 'Ölçme ve Doğrulama Sertifikası',
    issuer: 'ETKB',
    category: 'Uzmanlık Sertifikaları',
    scope: 'Enerji verimliliği projelerinin M&V — merkezi sınav',
  },
  {
    id: 'ges-tasarim',
    name: 'Güneş Enerjisi Sistemleri Tesisatı (MİSEM Kod 36.0001)',
    issuer: 'EMO',
    category: 'Uzmanlık Sertifikaları',
    scope: 'Fotovoltaik tasarım, kurulum, şebeke bağlantısı',
  },
  {
    id: 'topraklama-egitim',
    name: 'Elektrik Tesislerinde Topraklamalar Eğitimi',
    issuer: 'EMO',
    category: 'Uzmanlık Sertifikaları',
    scope: 'Elk/Elk-Elektronik/Elektronik/Elektronik-Haberleşme Müh.',
  },
  {
    id: 'ic-tesisat-denetim',
    name: 'Elektrik İç Tesisat Denetim',
    issuer: 'EMO',
    category: 'Uzmanlık Sertifikaları',
    scope: 'İç tesisat denetim yetkisi',
  },
  {
    id: 'periyodik-kontrol-elektrik',
    name: 'Periyodik Kontrol (Elektrik Tesisleri)',
    issuer: 'EMO',
    category: 'Uzmanlık Sertifikaları',
    scope: 'İş Ekipmanları Periyodik Kontrol',
  },
  {
    id: 'bilisim-guvenligi',
    name: 'Bilişim Güvenliği',
    issuer: 'EMO',
    category: 'Uzmanlık Sertifikaları',
  },
  {
    id: 'rayli-sistemler',
    name: 'Raylı Sistemler',
    issuer: 'EMO',
    category: 'Uzmanlık Sertifikaları',
    scope: 'Sektörel uzmanlaşma',
  },
  {
    id: 'mmo-isek-periyodik',
    name: 'İş Ekipmanları Periyodik Kontrol (MMO)',
    issuer: 'MMO',
    category: 'Uzmanlık Sertifikaları',
  },
  {
    id: 'mmo-basincli-kap',
    name: 'Basınçlı Kap Periyodik Kontrol (MMO)',
    issuer: 'MMO',
    category: 'Uzmanlık Sertifikaları',
  },
  {
    id: 'mmo-kaldirma-iletme',
    name: 'Kaldırma-İletme Ekipmanları Periyodik Kontrol (MMO)',
    issuer: 'MMO',
    category: 'Uzmanlık Sertifikaları',
  },

  // ─── 5. Ulusal Yeterlilik (Saha) — MYK ────────────────────────────
  {
    id: 'myk-pano-sv3',
    name: 'MYK Elektrik Pano Montajcısı (12UY0075) — Seviye 3',
    issuer: 'MYK',
    category: 'Ulusal Yeterlilik (Saha)',
    scope: 'Seviye 3',
    validityMonths: 60,
    verifyUrl: 'https://portal.myk.gov.tr',
  },
  {
    id: 'myk-pano-sv4',
    name: 'MYK Elektrik Pano Montajcısı — Seviye 4',
    issuer: 'MYK',
    category: 'Ulusal Yeterlilik (Saha)',
    scope: 'Seviye 4',
    validityMonths: 60,
    verifyUrl: 'https://portal.myk.gov.tr',
  },
  {
    id: 'myk-pano-sv5',
    name: 'MYK Elektrik Pano Montajcısı — Seviye 5',
    issuer: 'MYK',
    category: 'Ulusal Yeterlilik (Saha)',
    scope: 'Seviye 5',
    validityMonths: 60,
    verifyUrl: 'https://portal.myk.gov.tr',
  },
  {
    id: 'myk-tesisat-sv3',
    name: 'MYK Elektrik Tesisatçısı (15UY0241) — Seviye 3',
    issuer: 'MYK',
    category: 'Ulusal Yeterlilik (Saha)',
    scope: 'Seviye 3',
    validityMonths: 60,
    verifyUrl: 'https://portal.myk.gov.tr',
  },
  {
    id: 'myk-tesisat-sv4',
    name: 'MYK Elektrik Tesisatçısı — Seviye 4',
    issuer: 'MYK',
    category: 'Ulusal Yeterlilik (Saha)',
    scope: 'Seviye 4 (MEB denklik → Ustalık)',
    validityMonths: 60,
    verifyUrl: 'https://portal.myk.gov.tr',
  },
  {
    id: 'myk-elektromek-sv4',
    name: 'MYK Elektro-Mekanik Montaj İşçisi (15UY0206) — Seviye 4',
    issuer: 'MYK',
    category: 'Ulusal Yeterlilik (Saha)',
    scope: 'Seviye 4',
    validityMonths: 60,
    verifyUrl: 'https://portal.myk.gov.tr',
  },

  // ─── 6. Tamamlayıcı Eğitim — Üniversite SEM ───────────────────────
  {
    id: 'sem-ders-tamamlama',
    name: 'SMM Yetki Belgesi Ders Tamamlama Programı',
    issuer: 'Üniversite SEM',
    category: 'Tamamlayıcı Eğitim',
    scope: 'EE/Elektronik/Elektronik-Haberleşme Müh. için 1 kV altı+üstü SMM ders tamamlama',
    note: 'Karma format, 3 ders × ~42 saat. %70 devam + ara + final.',
  },
  {
    id: 'sem-yenilenebilir',
    name: 'Yenilenebilir Enerji Teknolojileri Sertifikası',
    issuer: 'Üniversite SEM',
    category: 'Tamamlayıcı Eğitim',
  },
  {
    id: 'sem-iha',
    name: 'İHA Pilot Eğitimi (Seviye 1–4)',
    issuer: 'Üniversite SEM',
    category: 'Tamamlayıcı Eğitim',
  },
  {
    id: 'sem-scada',
    name: 'SCADA Programlama',
    issuer: 'Üniversite SEM',
    category: 'Tamamlayıcı Eğitim',
  },
  {
    id: 'sem-plc',
    name: 'PLC Otomasyon',
    issuer: 'Üniversite SEM',
    category: 'Tamamlayıcı Eğitim',
  },
  {
    id: 'sem-cbs',
    name: 'CBS (Coğrafi Bilgi Sistemleri)',
    issuer: 'Üniversite SEM',
    category: 'Tamamlayıcı Eğitim',
  },

  // ─── 7. MEB Belgeleri ──────────────────────────────────────────────
  {
    id: 'meb-tesisat-3',
    name: 'MEB Elektrik Tesisatçılığı Yetki Belgesi — 3. Sınıf',
    issuer: 'MEB',
    category: 'MEB Belgeleri',
    scope: 'Kalfalık sınavına katılma şartları',
    verifyUrl: 'https://turkiye.gov.tr',
  },
  {
    id: 'meb-tesisat-2',
    name: 'MEB Elektrik Tesisatçılığı — 2. Sınıf',
    issuer: 'MEB',
    category: 'MEB Belgeleri',
    scope: '3. sınıf + 2. sınıf eğitim programı veya ustalık şartları',
    verifyUrl: 'https://turkiye.gov.tr',
  },
  {
    id: 'meb-tesisat-1',
    name: 'MEB Elektrik Tesisatçılığı — 1. Sınıf',
    issuer: 'MEB',
    category: 'MEB Belgeleri',
    scope: '2. sınıf + 1. sınıf eğitim programı',
    verifyUrl: 'https://turkiye.gov.tr',
  },
  {
    id: 'meb-ustalik',
    name: 'Ustalık Belgesi (MYK Sv4 Denklik)',
    issuer: 'MEB',
    category: 'MEB Belgeleri',
    verifyUrl: 'https://turkiye.gov.tr',
  },
  {
    id: 'meb-kalfalik',
    name: 'Kalfalık Belgesi',
    issuer: 'MEB',
    category: 'MEB Belgeleri',
    verifyUrl: 'https://turkiye.gov.tr',
  },
  {
    id: 'meb-halk-scada-64',
    name: 'MEB Halk Eğitim — SCADA Programlama (64 saat)',
    issuer: 'MEB',
    category: 'MEB Belgeleri',
  },
  {
    id: 'meb-halk-plc',
    name: 'MEB Halk Eğitim — PLC Programlama',
    issuer: 'MEB',
    category: 'MEB Belgeleri',
  },
  {
    id: 'meb-halk-endustriyel-elk',
    name: 'MEB Halk Eğitim — Endüstriyel Elektronik',
    issuer: 'MEB',
    category: 'MEB Belgeleri',
  },
  {
    id: 'meb-halk-bobinaj',
    name: 'MEB Halk Eğitim — Bobinaj',
    issuer: 'MEB',
    category: 'MEB Belgeleri',
  },
  {
    id: 'meb-halk-asansor-bakim',
    name: 'MEB Halk Eğitim — Asansör Bakım',
    issuer: 'MEB',
    category: 'MEB Belgeleri',
  },

  // ─── 8. Bilirkişilik ───────────────────────────────────────────────
  {
    id: 'bilirkisi-temel',
    name: 'Bilirkişilik Temel Eğitimi',
    issuer: 'Adalet Bakanlığı',
    category: 'Bilirkişilik',
    scope: 'Bilirkişi listesi kaydı için zorunlu',
  },
  {
    id: 'bilirkisi-uzmanlik',
    name: 'Bilirkişilik Uzmanlık Eğitimi (EMO)',
    issuer: 'EMO',
    category: 'Bilirkişilik',
    scope: 'Adalet Bakanlığı bilirkişi listesi tamamlayıcı',
  },

  // ─── 9. LPG / EPDK ─────────────────────────────────────────────────
  {
    id: 'lpg-isletme-personel',
    name: 'LPG Yetkili İşletme Personeli',
    issuer: 'EPDK',
    category: 'LPG / EPDK',
    scope: 'Eğitim EMO/MMO tarafından verilir',
  },
  {
    id: 'lpg-teknik-personel',
    name: 'LPG Yetkili Teknik Personel',
    issuer: 'EPDK',
    category: 'LPG / EPDK',
  },
  {
    id: 'lpg-sorumlu-mudur',
    name: 'LPG Sorumlu Müdür',
    issuer: 'EPDK',
    category: 'LPG / EPDK',
  },
];

// Edit/görüntüle için alanlar (UI bu sıralama referans alır)
const CERT_FIELDS = [
  { key: 'name',        label: 'Sertifika / Eğitim Adı', required: true },
  { key: 'issuer',      label: 'Veren Kurum' },
  { key: 'category',    label: 'Kategori' },
  { key: 'scope',       label: 'Seviye / Kapsam' },
  { key: 'date',        label: 'Veriliş Tarihi',  type: 'date' },
  { key: 'expiry',      label: 'Son Geçerlilik',  type: 'date' },
  { key: 'documentNo',  label: 'Belge / Sicil No' },
  { key: 'verifyUrl',   label: 'Doğrulama Linki', type: 'url' },
  { key: 'fileUrl',     label: 'Belge Dosyası (URL)', type: 'url' },
  { key: 'visibility',  label: 'Gizlilik', type: 'select', options: [
      { value: 'public',      label: 'Herkese Açık' },
      { value: 'connections', label: 'Bağlantılar' },
      { value: 'private',     label: 'Gizli' },
  ] },
  { key: 'notes',       label: 'Notlar',         type: 'textarea' },
];

// Gizlilik seçenekleri — bölüm 10.2 gizlilik alanı
const VISIBILITY_OPTIONS = [
  { value: 'public',      label: 'Herkese Açık' },
  { value: 'connections', label: 'Bağlantılar' },
  { value: 'private',     label: 'Gizli' },
];

export { ELECTRICAL_CERTIFICATES, CERT_FIELDS, CERT_CATEGORIES, ISSUERS, VISIBILITY_OPTIONS };
